import { GOLD_SET_PASS_PARAM } from '../config'

export function getGoldSetQueueUrl(pass: number) {
  return `/gold-set?${GOLD_SET_PASS_PARAM}=${pass}`
}

export function getGoldSetReviewUrl(documentKey: string, pass: number) {
  return `/gold-set/${encodeURIComponent(documentKey)}?${GOLD_SET_PASS_PARAM}=${pass}`
}
